import { render, staticRenderFns } from "./BackupResultModel.vue?vue&type=template&id=2007cb65&"
import script from "./BackupResultModel.vue?vue&type=script&lang=ts&"
export * from "./BackupResultModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports